import { useState } from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import expensesCategoriesContractsTaxonomies from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'
import policyPeriods from 'modules/payroll_bundle/store/collections/policyPeriods'

import { PayrollExpensableDetail } from '../types/PayrollExpensableDetail'

type WithLoading<T> = T & { loading: boolean }

export const usePayroll = (
  canReimburseThroughPayroll: boolean
): WithLoading<PayrollExpensableDetail> => {
  const [categories, setCategories] = useState<string[]>([])
  const [currentPeriodOpen, setCurrentPeriodOpen] = useState<boolean>(false)

  const { loading } = useAsyncData(() => {
    if (!canReimburseThroughPayroll) return Promise.resolve()

    return Promise.all([
      expensesCategoriesContractsTaxonomies.existingTaxonomies().then(setCategories),
      policyPeriods
        .isCurrentOpen()
        .then(({ open_to_supplements }) => setCurrentPeriodOpen(open_to_supplements)),
    ])
  }, [canReimburseThroughPayroll])

  return {
    categories,
    currentPeriodOpen,
    loading,
  }
}
